import React from 'react'

import TbdBlock from '../../components/mainComponents/TbdBlock/TbdBlock'

const TbdPage = () => <TbdBlock />

export default React.memo(TbdPage)
